// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Grid,
//   Paper,
//   Button,
//   Divider,
//   Avatar,
//   FormControlLabel,
//   Checkbox,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
// } from "@mui/material";
// import { useLocation, useNavigate } from "react-router-dom";
// import "../../styles/Booking.scss";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
// import GroupIcon from "@mui/icons-material/Group";
// import ReceiptIcon from "@mui/icons-material/Receipt";
// import LocalOfferIcon from "@mui/icons-material/LocalOffer";
// import PercentIcon from "@mui/icons-material/Percent";
// import CloseIcon from "@mui/icons-material/Close";
// import PersonIcon from "@mui/icons-material/Person";
// import {
//   BOOKING_PASSENGER_DETAILS,
//   BOOKINGS,
//   DEV_PAYMENT_PROCESSING,
//   LOGIN,
//   SUCCESS_PAGE,
//   UNAUTHORIZE_BOOKING_PASSENGER_DETAILS,
// } from "../../component/common/Routes/AppRoutes";
// import PerfectScrollbar from "react-perfect-scrollbar";
// import "react-perfect-scrollbar/dist/css/styles.css";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   CUSTOMER_BOOKING_PASSENGER_DETAILS,
//   CUSTOMER_BOOKINGS,
// } from "../../component/common/Routes/CustomerRoutes";
// import {
//   VENDOR_BOOKING_PASSENGER_DETAILS,
//   VENDOR_BOOKINGS,
// } from "../../component/common/Routes/VendorRoutes";
// import {
//   addBookingRequest,
//   insertInstantBookingRequest,
//   resetBookingDetails,
// } from "../../redux/Bookings/BookingAction";
// import { toast, ToastContainer } from "react-toastify";
// import CustomButton from "../../component/ui/FormFields/Button";
// import ControlledTextInputField from "../../component/ui/FormFields/ControlledTextInputField";
// import { Controller, useForm } from "react-hook-form";
// import StatusRadioGroup from "../../component/ui/FormFields/StatusRadioGroup";
// import TopBar from "../../component/common/components/TopBar";
// import { convertDateFormat, convertDateFormatBooking } from "../../Style";
// import PassengerInfoTable from "./PassengerInfoTable";
// import AirportDetailsTable from "./AirportDetailsTable";

// const BookingInvoice = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const user = useSelector((state) => state.auth.user);
//   const booking = useSelector((state) => state?.booking);
//   const dispatch = useDispatch();
//   const [showDiscount, setShowDiscount] = useState(false);
//   const [showLoginPopup, setShowLoginPopup] = useState(false);
//   const form1Value = location.state?.form1Value || {};
//   const form2Value = location.state?.form2Value || {};
//   const form3Value = location.state?.form3Value || {};

//   const paymentUrl = booking?.instantBooking?.data?.paymentUrl;

//   useEffect(() => {
//     document.body.classList.add("booking-page");
//     return () => {
//       document.body.classList.remove("booking-page");
//     };
//   }, []);

//   useEffect(() => {
//     if (paymentUrl) {
//       localStorage.removeItem("newBookingAccessToken");
//       window.location.href = paymentUrl;
//       toast.success("The payment link has been shared successfully.", {
//         position: "top-center",
//         autoClose: 3000,
//         onClose: () => {
//           dispatch(resetBookingDetails());
//         },
//       });
//     }
//   }, [paymentUrl]);

//   const {
//     watch,
//     setError,
//     setValue,
//     clearErrors,
//   } = useForm({
//     defaultValues: {
//       discount: form3Value?.discount || 0,
//       applyDiscount: form3Value?.applyDiscount || false,
//       applyComplementary: form3Value?.applyComplementary || false,
//     },
//   });

//   useEffect(() => {
//     dispatch(resetBookingDetails());
//   }, []);

//   const formValue = watch();

//   const errorMessage = booking?.instantBooking;

//   // Function to check if error is about duplicate email/contact
//   const isDuplicateError = (errorMsg) => {
//     if (!errorMsg) return false;
//     const lowerCaseError = errorMsg.toLowerCase();
//     return (
//       lowerCaseError.includes("email must be unique") ||
//       lowerCaseError.includes("contact must be unique") ||
//       lowerCaseError.includes("email already exists") ||
//       lowerCaseError.includes("contact already exists") ||
//       lowerCaseError.includes("already registered")
//     );
//   };

//   useEffect(() => {
//     if (errorMessage?.error) {
//       if (isDuplicateError(errorMessage.error)) {
//         // Show popup for duplicate email/contact
//         setShowLoginPopup(true);
//       } else {
//         // Show toast for other errors
//         toast.error(errorMessage.error, {
//           position: "top-center",
//           autoClose: 3000,
//           onClose: () => {
//             dispatch(resetBookingDetails());
//           },
//         });
//       }
//     }
//   }, [errorMessage]);

//   const service = form1Value?.arrival_departure_type?.value || "";

//   useEffect(() => {
//     setShowDiscount(formValue?.applyDiscount || false);
//   }, [formValue?.applyDiscount]);

//   const loading = booking?.loading;

//   const adultFamilyMember = form2Value?.adults;
//   const infantFamilyMember = form2Value?.infants;
//   const childFamilyMember = form2Value?.children;

//   const adultDiscount = adultFamilyMember?.[0]?.discount || 0;
//   const childDiscount = childFamilyMember?.[0]?.discount || 30;
//   const infantDiscount = infantFamilyMember?.[0]?.discount || 100;

//   const adults = form2Value?.adults.map((value, index) => {
//     return {
//       ...value,
//       country_code: value.country_code?.value,
//       dob: convertDateFormat(value?.dob),
//     };
//   });

//   const childerns = form2Value?.children.map((value, index) => {
//     return {
//       ...value,
//       country_code: value.country_code?.value,
//       dob: convertDateFormat(value?.dob),
//     };
//   });

//   const infants = form2Value?.infants.map((value, index) => {
//     return {
//       ...value,
//       country_code: value.country_code?.value,
//       dob: convertDateFormat(value?.dob),
//     };
//   });

//   const familyMember = [
//     ...(adults || []),
//     ...(childerns || []),
//     ...(infants || []),
//   ];
//     const servicePlans=[form1Value?.arrival_plan?.label,form1Value?.departure_plan?.label,form1Value?.transit_plan?.label];
// const isPorterService=servicePlans?.some((service)=> service?.toLowerCase().includes("porter"));
//   const bookingValue = {
//     airport_id: form1Value?.airport?.value || "-",
//     type_of_class: form1Value?.type_of_class?.value,
//     airport_type: form1Value?.service_type === "Domestic" ? "1" : "2",
//     first_name: form2Value?.first_name,
//     last_name: form2Value?.last_name,
//     address1: form2Value?.address1,
//     address2: form2Value?.address2,
//     city: form2Value?.city?.value,
//     state: form2Value?.state?.value,
//     display_name: `${form2Value?.first_name} ${form2Value?.last_name} `,
//     email: form2Value?.email,
//     country: form2Value?.country?.value,
//     pincode: form2Value?.pincode,
//     phone_number: form2Value?.phone,
//     dob: convertDateFormat(form2Value?.dob) || "2025-04-02",
//     nationality: form2Value?.country?.label,
//     phone: form2Value?.phone,
//     country_code: form2Value?.country_code?.value || "-",
//     emergency_contact: form2Value?.emergency_contact,
//     company_name: form2Value?.company_name,
//     emergency_country_code: form2Value?.emergency_country_code?.value || "-",
//     service_type:
//       form1Value?.arrival_departure_type?.value === "Arrival"
//         ? "1"
//         : form1Value?.arrival_departure_type?.value === "Departure"
//         ? "2"
//         : "3" || "-",
//     service_id:
//       form1Value?.arrival_plan?.value ||
//       form1Value?.departure_plan?.value ||
//       form1Value?.transit_plan?.value ||
//       "-",
//     number_of_adults: form2Value?.no_of_adult || "0",
//     number_of_child: form2Value?.no_of_child || "0",
//     number_of_infant: form2Value?.no_of_infant || "0",
//     pan_number:form2Value.pan_number|| '',
//       customer_gst_no: form2Value.customer_gst_no||'',
//     date_of_departure:
//       convertDateFormatBooking(form1Value?.departure_date) || null,
//     time_of_departure: form1Value?.departure_time || null,
//     departure_airlines: form1Value?.departure_airline || "-",
//     arrival_from_city: form1Value?.arrival_city || "-",
//     departure_from_city: form1Value?.departure_city || "-",
//     departure_flight_number: form1Value?.departure_flight_number || "-",
//     arrival_airlines: form1Value?.arrival_airline || "-",
//     time_of_arrival: form1Value?.arrival_time || null,
//     date_of_arrival: convertDateFormatBooking(form1Value?.arrival_date) || null,
//     total_passengers: form2Value?.total_passengers || "0",
//     notes: form2Value?.notes || "-",
//     gst_number: form2Value?.gst_number || "-",
//     arrival_flight_number: form1Value?.arrival_flight_number || "-",
//     arival_pnr_by_customer: form1Value?.arival_pnr_by_customer || "-",
//     departure_pnr_by_customer: form1Value?.departure_pnr_by_customer || "-",
//     number_of_service: form2Value?.no_of_service || "-",
//     family_members: familyMember || "-",
//     proof_url: "",
//     gender_type: "M",
//     success_url: DEV_PAYMENT_PROCESSING,
//     failure_url: DEV_PAYMENT_PROCESSING,
//     booked_type: 1,
//      booked_service:isPorterService?"2":"1",
//          is_mobile:1
//   };

//   const submitBookingData = () => {
//     dispatch(insertInstantBookingRequest(bookingValue));
//   };

//   const handleCloseLoginPopup = () => {
//     setShowLoginPopup(false);
//     dispatch(resetBookingDetails());
//   };

//   const handleLoginRedirect = () => {
//     // Replace with your actual login route
//     const loginUrl = {LOGIN};
//     window.location.href = loginUrl;
//   };

//   const bookingData = [
//     {
//       icon: <GroupIcon className="passenger-icon" />,
//       title: "Passenger Details",
//       fields: [
//         { label: "No. of Adults", value: form2Value.no_of_adult || 0 },
//         { label: "No. of Children", value: form2Value.no_of_child || 0 },
//         { label: "No. of Infants", value: form2Value.no_of_infant || 0 },
//         { label: "Total Passengers", value: form2Value.total_passengers || 0 },
//       ],
//     },
//     {
//       icon: <FlightTakeoffIcon className="service-icon" />,
//       title: "Service Details",
//       fields: [
//         { label: "Service", value: service || "-" },
//         { label: "Service Type", value: form1Value.service_type.value || "-" },
//         { label: "Service Plan", value: form1Value.service_type.value || "-" },
//         {
//           label: "Number of Services",
//           value: form2Value.no_of_service || "0",
//         },
//       ],
//     },
//     {
//       icon: <LocationOnIcon className="location-icon" />,
//       title: "Airport Details",
//       fields:
//         service === "Arrival"
//           ? [
//               {
//                 label: "Travel class",
//                 value: form1Value.type_of_class.label || "-",
//               },
//               { label: "Airport", value: form1Value.airport.label || "" },
//               {
//                 label: "Arrival Date & Time",
//                 value:
//                   `${form1Value.arrival_date} - ${form1Value.arrival_time} ` ||
//                   "",
//               },
//               {
//                 label: "Arrival Flight Number",
//                 value: form1Value.arrival_flight_number || "",
//               },
//               {
//                 label: "Arrival PNR Number",
//                 value: form1Value.arival_pnr_by_customer || "",
//               },
//               {
//                 label: "Arrival Airline",
//                 value: form1Value.arrival_airline || "",
//               },
//             ]
//           : service === "Departure"
//           ? [
//               {
//                 label: "Travel class",
//                 value: form1Value.type_of_class.label || "-",
//               },
//               { label: "Airport", value: form1Value.airport.label || "-" },
//               {
//                 label: "Departure Date & Time",
//                 value:
//                   `${form1Value.departure_date} - ${form1Value.departure_time} ` ||
//                   "",
//               },
//               {
//                 label: "Departure Flight Number",
//                 value: form1Value.departure_flight_number || "-",
//               },
//               {
//                 label: "Departure PNR Number",
//                 value: form1Value.departure_pnr_by_customer || "-",
//               },
//               {
//                 label: "Departure Airline",
//                 value: form1Value.departure_airline || "-",
//               },
//             ]
//           : [
//               {
//                 label: "Travel class",
//                 value: form1Value.type_of_class.label || "-",
//               },
//               { label: "Airport", value: form1Value.airport.label || "-" },
//               {
//                 label: "Arrival Date & Time",
//                 value:
//                   `${form1Value.arrival_date} - ${form1Value.arrival_time} ` ||
//                   "",
//               },
//               {
//                 label: "Arrival Flight Number",
//                 value: form1Value.arrival_flight_number || "-",
//               },
//               {
//                 label: "Arrival PNR Number",
//                 value: form1Value.arival_pnr_by_customer || "-",
//               },
//               {
//                 label: "Arrival Airline",
//                 value: form1Value.arrival_airline || "-",
//               },
//               {
//                 label: "Departure Date & Time",
//                 value:
//                   `${form1Value.departure_date} - ${form1Value.departure_time} ` ||
//                   "",
//               },
//               {
//                 label: "Departure Flight Number",
//                 value: form1Value.departure_flight_number || "-",
//               },
//               {
//                 label: "Departure PNR Number",
//                 value: form1Value.departure_pnr_by_customer || "-",
//               },
//               {
//                 label: "Departure Airline",
//                 value: form1Value.departure_airline || "-",
//               },
//             ],
//     },
//   ];

//   const currencyFormatter = new Intl.NumberFormat("en-IN", {
//     style: "currency",
//     currency: "INR",
//     minimumFractionDigits: 2,
//   });

//   const discountValue = formValue?.discount;
//   const no_of_child_after_discount =
//     childDiscount > 0 
//       ?(childFamilyMember.length * childDiscount) / 100
//       : childFamilyMember.length;



// const Gross_Total_Service=form2Value.no_of_service;
// const no_of_service =isPorterService?parseInt( form2Value.no_of_service ):parseInt( form2Value.no_of_service )-no_of_child_after_discount;
// const servicePrice = form1Value.servicePlanPrice ;


//   const [discountPrice, setDiscountPrice] = useState(servicePrice);
//   const [discountAmout, setDisountAmount] = useState(0);

//   const discountedPrices = (customDiscountValue) => {
//     if (discountValue > 100) {
//       setError("discount", { message: "Enter Between 0-100 %" });
//     } else {
//       const newDiscountValue =
//         customDiscountValue >= 0 ? customDiscountValue : discountValue;
//       clearErrors("discount");
//       setDisountAmount(servicePrice * (newDiscountValue / 100));
//       setDiscountPrice(servicePrice - servicePrice * (newDiscountValue / 100));
//     }
//   };

//   const subTotal =
//     parseFloat(no_of_service * servicePrice) - (parseFloat(discountAmout) || 0);

//   const orderSummary = {
//     totals: [
//       form1Value?.servicePlanPrice && {
//         label: "Gross Amount",
//         value: 0,
//         formattedValue: currencyFormatter.format(
//           parseFloat(Gross_Total_Service * servicePrice) || 0
//         ),
//       },
//       (adultFamilyMember?.length > 0&& !isPorterService) && {
//         label: `Adult Discount(${adultDiscount}%)`,
//         value: 0,
//         formattedValue: currencyFormatter.format(
//           -parseFloat(
//             adultFamilyMember?.length * (adultDiscount / 100) * servicePrice
//           ) || 0
//         ),
//       },
//       (childFamilyMember?.length > 0&& !isPorterService) && {
//         label: `Child Discount(${childDiscount}%)`,
//         value: 0,
//         formattedValue: currencyFormatter?.format(
//           -parseFloat(
//             childFamilyMember?.length * (childDiscount / 100) * servicePrice
//           ) || 0
//         ),
//       },
 
//       form1Value?.servicePlanPrice && {
//         label: "SubTotal",
//         value: parseFloat(subTotal?.toFixed(2)),
//         formattedValue: currencyFormatter.format(
//           parseFloat(subTotal?.toFixed(2)) || 0
//         ),
//       },
//       form1Value?.tax > 0 && {
//         label: `IGST (${form1Value?.tax_percentage}%)`,
//         value:
//           parseFloat(subTotal?.toFixed(2)) *
//             (parseFloat(form1Value.tax_percentage) / 100) || 0,
//         formattedValue: currencyFormatter.format(
//           parseFloat(subTotal?.toFixed(2)) *
//             (parseFloat(form1Value.tax_percentage) / 100) || 0
//         ),
//       },
//       form1Value?.sgst > 0 && {
//         label: `SGST (${form1Value?.sgst_percentage}%)`,
//         value:
//           parseFloat(subTotal?.toFixed(2)) *
//             (parseFloat(form1Value.sgst_percentage) / 100) || 0,
//         formattedValue: currencyFormatter.format(
//           parseFloat(subTotal?.toFixed(2)) *
//             (parseFloat(form1Value.sgst_percentage) / 100) || 0
//         ),
//       },
//       form1Value?.cgst > 0 && {
//         label: `CGST (${form1Value?.cgst_percentage}%)`,
//         value:
//           parseFloat(subTotal?.toFixed(2)) *
//             (parseFloat(form1Value.cgst_percentage) / 100) || 0,
//         formattedValue: currencyFormatter.format(
//           parseFloat(subTotal?.toFixed(2)) *
//             (parseFloat(form1Value.cgst_percentage) / 100) || 0
//         ),
//       },
//     ].filter(Boolean),
//   };

//   const totalAmount = orderSummary.totals.reduce(
//     (sum, item) => sum + item.value,
//     0
//   );
//   const formattedTotalAmount = currencyFormatter.format(totalAmount);

//   const passengerInformation = {
//     icon: <GroupIcon className="passenger-icon" />,
//     title: "Passengers Informations",
//     fields: [
//       {
//         label: "Adults",
//         value: form2Value.adults.map((adult) => {
//           return {
//             totals: [
//               { label: "First Name", value: adult?.first_name },
//               { label: "Last Name", value: adult?.last_name },
//               { label: "DOB", value: adult?.dob },
//               {
//                 label: "Mobile No",
//                 value: `+ ${adult?.country_code?.value}-${adult?.phone}`,
//               },
//               { label: "Gender", value: adult?.gender_type },
//               adult?.aadhar_number !== ""
//                 ? { label: "Aadhar No ", value: adult?.aadhar_number || "-" }
//                 : {
//                     label: "Passport No ",
//                     value: adult?.passport_number || "-",
//                   },
//               { label: "Nationality", value: adult?.nationality || "-" },
//             ],
//           };
//         }),
//       },
//       {
//         label: "Child",
//         value: form2Value.children.map((child) => {
//           return {
//             totals: [
//               { label: "First Name", value: child?.first_name },
//               { label: "Last Name", value: child?.last_name },
//               { label: "DOB", value: child?.dob },
//               {
//                 label: "Mobile No",
//                 value: `+ ${child?.country_code?.value}-${child?.phone}`,
//               },
//               { label: "Gender", value: child?.gender_type },
//               child?.aadhar_number !== ""
//                 ? { label: "Aadhar No ", value: child?.aadhar_number || "-" }
//                 : {
//                     label: "Passport No ",
//                     value: child?.passport_number || "-",
//                   },
//               { label: "Nationality", value: child?.nationality || "-" },
//             ],
//           };
//         }),
//       },
//       {
//         label: "Infant",
//         value: form2Value.infants.map((infant) => {
//           return {
//             totals: [
//               { label: "First Name", value: infant?.first_name },
//               { label: "Last Name", value: infant?.last_name },
//               { label: "DOB", value: infant?.dob },
//               {
//                 label: "Mobile No",
//                 value: `+ ${infant?.country_code?.value}-${infant?.phone}`,
//               },
//               { label: "Gender", value: infant?.gender_type },
//               infant?.aadhar_number !== ""
//                 ? { label: "Aadhar No ", value: infant?.aadhar_number || "-" }
//                 : {
//                     label: "Passport No ",
//                     value: infant?.passport_number || "-",
//                   },
//               { label: "Nationality", value: infant?.nationality || "-" },
//             ],
//           };
//         }),
//       },
//     ],
//   };

//   useEffect(() => {
//     discountedPrices();
//   }, []);

//   const updateDiscountValues = async (isChecked) => {
//     if (isChecked) {
//       setValue("applyComplementary", false);
//     } else {
//       setValue("applyDiscount", false);
//       setValue("discount", 0);
//       discountedPrices(0);
//     }
//   };

//   const updateComplementaryValue = async (isChecked) => {
//     if (isChecked) {
//       setValue("applyDiscount", false);
//       setValue("discount", 0);
//       discountedPrices(0);
//     } else {
//       setValue("applyComplementary", false);
//     }
//   };

//   const renderFields = (fields) =>
//     fields.map((item, index) => (
//       <Box key={index} className="label-value-container">
//         <Typography variant="body1" className="label-style">
//           {item.label}
//         </Typography>
//         <Typography variant="body1" className="value-style">
//           {item.value}
//         </Typography>
//       </Box>
//     ));

//   return (
//     <>
//       <TopBar unAuth={true} />
//       <ToastContainer />
      
//       {/* Custom Login Popup */}
//       <Dialog
//         open={showLoginPopup}
//         onClose={handleCloseLoginPopup}
//         maxWidth="sm"
//         fullWidth
//         sx={{
//           '& .MuiDialog-paper': {
//             borderRadius: '12px',
//             padding: '20px',
//           }
//         }}
//       >
//         <DialogTitle
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             paddingBottom: '10px',
//           }}
//         >
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//             <Avatar sx={{ bgcolor: '#ff6b35' }}>
//               <PersonIcon />
//             </Avatar>
//             <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
//               Account Already Exists
//             </Typography>
//           </Box>
//           <IconButton onClick={handleCloseLoginPopup}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
        
//         <DialogContent>
//           <Typography variant="body1" sx={{ marginBottom: 2, color: '#666' }}>
//             You have already registered with this email or contact number. 
//             Please login to your account to continue with the booking.
//           </Typography>
//           <Typography variant="body2" sx={{ color: '#888' }}>
//             If you've forgotten your password, you can reset it on the login page.
//           </Typography>
//         </DialogContent>
        
//         <DialogActions sx={{ paddingTop: '20px', gap: 1 }}>
//           <Button
//             onClick={handleCloseLoginPopup}
//             variant="outlined"
//             sx={{
//               color: '#666',
//               borderColor: '#ddd',
//               '&:hover': {
//                 borderColor: '#bbb',
//                 backgroundColor: '#f5f5f5',
//               },
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleLoginRedirect}
//             variant="contained"
//             sx={{
//               backgroundColor: '#ff6b35',
//               '&:hover': {
//                 backgroundColor: '#e55a2b',
//               },
//             }}
//           >
//             Login & Continue
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Box className="container">
//         <Box sx={{ marginTop: "100px" }}>
//           <Grid container spacing={4}>
//             {/* Passenger Details (First Box) */}
//             {bookingData[0] && (
//               <Grid
//                 item
//                 xs={12}
//                 md={6}
//                 xl={6}
//                 key="row1-box1"
//               >
//                 <Paper elevation={4} className="booking-summary-paper">
//                   <Box className="booking-summary-content-box">
//                     <Box className="booking-heading-alignment">
//                       <Avatar className="booking-summary-avatar-style">
//                         {bookingData[0].icon}
//                       </Avatar>
//                       <Typography
//                         variant="h6"
//                         className="booking-summary-title-style"
//                       >
//                         {bookingData[0].title}
//                       </Typography>
//                     </Box>
//                     <Divider
//                       sx={{
//                         margin: "10px 0",
//                         borderColor: "#ddd",
//                         width: "100%",
//                       }}
//                     />
//                   </Box>
//                   {renderFields(bookingData[0].fields)}
//                 </Paper>
//               </Grid>
//             )}

//             {/* Booking Details (Second Box) */}
//             {bookingData[1] && (
//               <Grid
//                 item
//                 xs={12}
//                 md={6}
//                 xl={6}
//                 key="row1-box2"
//               >
//                 <Paper elevation={4} className="booking-summary-paper">
//                   <Box className="booking-summary-content-box">
//                     <Box className="booking-heading-alignment">
//                       <Avatar className="booking-summary-avatar-style">
//                         {bookingData[1].icon}
//                       </Avatar>
//                       <Typography
//                         variant="h6"
//                         className="booking-summary-title-style"
//                       >
//                         {bookingData[1].title}
//                       </Typography>
//                     </Box>
//                     <Divider
//                       sx={{
//                         margin: "10px 0",
//                         borderColor: "#ddd",
//                         width: "100%",
//                       }}
//                     />
//                   </Box>
//                   {renderFields(bookingData[1].fields)}
//                 </Paper>
//               </Grid>
//             )}

//             {/* Passenger Information */}
//             <Grid item xs={12}>
//               <PassengerInfoTable form2Value={form2Value} />
//             </Grid>
//             {/* Airport Details (Third Box) */}
//             {bookingData[2] && (
//               <Grid item xs={12} md={6} xl={6} key="row1-box3">
//                 <AirportDetailsTable form1Value={form1Value} />
//               </Grid>
//             )}
//             {/* Order Summary */}
//             <Grid item xs={12} md={6}>
//               <Paper
//                 elevation={4}
//                 className="unauth-booking-summary-order-paper"
//               >
//                 <Box className="booking-summary-order-box">
//                   <Avatar className="booking-summary-order-avatar">
//                     <ReceiptIcon className="booking-summary-receipticon" />
//                   </Avatar>
//                   <Typography
//                     variant="h6"
//                     className="booking-summary-title-style"
//                   >
//                     Order Summary
//                   </Typography>
//                 </Box>
//                 <Divider className="booking-summary-divider" />

//                 {orderSummary.totals.map((item, index) => (
//                   <Box key={index} className="booking-summary-order-content">
//                     <Typography
//                       variant="body1"
//                       className="booking-summary-total-label"
//                     >
//                       {item.label}
//                     </Typography>
//                     <Typography
//                       variant="body1"
//                       className="booking-summary-total-value"
//                     >
//                       {item.formattedValue}
//                     </Typography>
//                   </Box>
//                 ))}
//                 <Divider className="booking-summary-divider" />
//                 <Box
//                   className="booking-summary-order-content"
//                   sx={{ paddingBottom: "20px" }}
//                 >
//                   <Typography
//                     variant="h6"
//                     className="booking-summary-total-label"
//                   >
//                     Total
//                   </Typography>
//                   <Typography
//                     variant="h6"
//                     className="booking-summary-total-value"
//                   >
//                     {formattedTotalAmount}
//                   </Typography>
//                 </Box>
//               </Paper>
//             </Grid>

//             {/* Next Button */}
//             <Grid item xs={12} className="unauth-button-container">
//               <Box display="flex" gap={2}>
//                 <Button
//                   variant="contained"
//                   className="grey-button"
//                   onClick={() => {
//                     let passengerDetailsRoute;

//                     passengerDetailsRoute =
//                       UNAUTHORIZE_BOOKING_PASSENGER_DETAILS;

//                     navigate(passengerDetailsRoute, {
//                       state: {
//                         form1Value: form1Value,
//                         form2Value: form2Value,
//                         form3Value: formValue,
//                       },
//                     });
//                   }}
//                 >
//                   Back
//                 </Button>

//                 {/* <Button
//               variant='contained'
//               onClick={submitBookingData}
//               className='orange-button'
//             >
//               Pay
//             </Button> */}
//                 <CustomButton
//                   variant="contained"
//                   className="orange-button"
//                   onClick={submitBookingData}
//                   loading={loading}
//                   text={formValue?.applyComplementary ? "Complmentary" : "Pay"}
//                 />
//               </Box>
//             </Grid>
//           </Grid>
//         </Box>
//       </Box>
//     </>
//   );
// };
// export default BookingInvoice;
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Button,
  Divider,
  Avatar,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import "../../styles/Booking.scss";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import GroupIcon from "@mui/icons-material/Group";
import ReceiptIcon from "@mui/icons-material/Receipt";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import PercentIcon from "@mui/icons-material/Percent";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import {
  BOOKING_PASSENGER_DETAILS,
  BOOKINGS,
  DEV_PAYMENT_PROCESSING,
  LOGIN,
  SUCCESS_PAGE,
  UNAUTHORIZE_BOOKING_PASSENGER_DETAILS,
} from "../../component/common/Routes/AppRoutes";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { useDispatch, useSelector } from "react-redux";
import {
  CUSTOMER_BOOKING_PASSENGER_DETAILS,
  CUSTOMER_BOOKINGS,
} from "../../component/common/Routes/CustomerRoutes";
import {
  VENDOR_BOOKING_PASSENGER_DETAILS,
  VENDOR_BOOKINGS,
} from "../../component/common/Routes/VendorRoutes";
import {
  addBookingRequest,
  insertInstantBookingRequest,
  resetBookingDetails,
} from "../../redux/Bookings/BookingAction";
import { toast, ToastContainer } from "react-toastify";
import CustomButton from "../../component/ui/FormFields/Button";
import ControlledTextInputField from "../../component/ui/FormFields/ControlledTextInputField";
import { Controller, useForm } from "react-hook-form";
import StatusRadioGroup from "../../component/ui/FormFields/StatusRadioGroup";
import TopBar from "../../component/common/components/TopBar";
import { convertDateFormat, convertDateFormatBooking } from "../../Style";
import PassengerInfoTable from "./PassengerInfoTable";
import AirportDetailsTable from "./AirportDetailsTable";
import { resetValidatePromoCode, validatePromoCodeRequest } from "../../redux/PromoCode/PromoCodeAction";
import PulseLoader from "react-spinners/PulseLoader";

const BookingInvoice = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const booking = useSelector((state) => state?.booking);
  const dispatch = useDispatch();
  const [showDiscount, setShowDiscount] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const form1Value = location.state?.form1Value || {};
  const form2Value = location.state?.form2Value || {};
  const form3Value = location.state?.form3Value || {};

  // Promo code related state (copied from normal booking)
  const [promoCode, setPromoCode] = useState("");
  const [appliedPromoCode, setAppliedPromoCode] = useState("");
  const [promoDiscount, setPromoDiscount] = useState(0);
  const [promoDiscountAmount, setPromoDiscountAmount] = useState(0);
  const validPromoLoading = useSelector(
    (state) => state.promoCode.promoCodeValidation.loading
  );
  const validPromoSuccess = useSelector(
    (state) => state.promoCode.promoCodeValidation.success
  );
  const validPromoError = useSelector(
    (state) => state.promoCode.promoCodeValidation.error
  );

  const paymentUrl = booking?.instantBooking?.data?.paymentUrl;

  useEffect(() => {
    document.body.classList.add("booking-page");
    return () => {
      document.body.classList.remove("booking-page");
    };
  }, []);

  useEffect(() => {
    if (paymentUrl) {
      handleRemovePromoCode();
      localStorage.removeItem("newBookingAccessToken");
      window.location.href = paymentUrl;
      toast.success("The payment link has been shared successfully.", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
      
          dispatch(resetBookingDetails());
        },
      });
    }
  }, [paymentUrl]);

  const {
    watch,
    setError,
    setValue,
    clearErrors,
  } = useForm({
    defaultValues: {
      discount: form3Value?.discount || 0,
      applyDiscount: form3Value?.applyDiscount || false,
      applyComplementary: form3Value?.applyComplementary || false,
    },
  });

  useEffect(() => {
    dispatch(resetBookingDetails());
  }, []);

  // Promo code useEffect (copied from normal booking)
  useEffect(() => {
    if (validPromoError) {
      setTimeout(() => {
        dispatch(resetValidatePromoCode());
      }, 5000);
    }
    if (validPromoSuccess) {
      setPromoDiscount(
        validPromoSuccess?.data?.discount_type == 1
          ? validPromoSuccess?.data?.discount_percent
          : validPromoSuccess?.data?.discount_value
      );
      setAppliedPromoCode(validPromoSuccess?.data?.discount_code);
    }
  }, [validPromoError, validPromoSuccess]);

  const formValue = watch();

  const errorMessage = booking?.instantBooking;

  // Function to check if error is about duplicate email/contact
  const isDuplicateError = (errorMsg) => {
    if (!errorMsg) return false;
    const lowerCaseError = errorMsg.toLowerCase();
    return (
      lowerCaseError.includes("email must be unique") ||
      lowerCaseError.includes("contact must be unique") ||
      lowerCaseError.includes("email already exists") ||
      lowerCaseError.includes("contact already exists") ||
      lowerCaseError.includes("already registered")
    );
  };

  useEffect(() => {
    if (errorMessage?.error) {
      if (isDuplicateError(errorMessage.error)) {
        // Show popup for duplicate email/contact
        setShowLoginPopup(true);
      } else {
        // Show toast for other errors
        toast.error(errorMessage.error, {
          position: "top-center",
          autoClose: 3000,
          onClose: () => {
            dispatch(resetBookingDetails());
          },
        });
      }
    }
  }, [errorMessage]);

  const service = form1Value?.arrival_departure_type?.value || "";

  useEffect(() => {
    setShowDiscount(formValue?.applyDiscount || false);
  }, [formValue?.applyDiscount]);

  const loading = booking?.loading;

  const adultFamilyMember = form2Value?.adults;
  const infantFamilyMember = form2Value?.infants;
  const childFamilyMember = form2Value?.children;

  const adultDiscount = adultFamilyMember?.[0]?.discount || 0;
  const childDiscount = childFamilyMember?.[0]?.discount || 30;
  const infantDiscount = infantFamilyMember?.[0]?.discount || 100;

  const adults = form2Value?.adults.map((value, index) => {
    return {
      ...value,
      country_code: value.country_code?.value,
      dob: convertDateFormat(value?.dob),
    };
  });

  const childerns = form2Value?.children.map((value, index) => {
    return {
      ...value,
      country_code: value.country_code?.value,
      dob: convertDateFormat(value?.dob),
    };
  });

  const infants = form2Value?.infants.map((value, index) => {
    return {
      ...value,
      country_code: value.country_code?.value,
      dob: convertDateFormat(value?.dob),
    };
  });

  const familyMember = [
    ...(adults || []),
    ...(childerns || []),
    ...(infants || []),
  ];
    const servicePlans=[form1Value?.arrival_plan?.label,form1Value?.departure_plan?.label,form1Value?.transit_plan?.label];
const isPorterService=servicePlans?.some((service)=> service?.toLowerCase().includes("porter"));

  // Promo code handlers (copied from normal booking)
  const handleApplyPromoCode = () => {
    dispatch(
      validatePromoCodeRequest({
        promocode: promoCode,
        service_id: bookingValue.service_id,
        applicable_platform: 1,
      })
    );
  };

  const handleRemovePromoCode = () => {
    setAppliedPromoCode("");
    setPromoDiscount(0);
    setPromoCode("");
    dispatch(resetValidatePromoCode());
  };

  const bookingValue = {
    airport_id: form1Value?.airport?.value || "-",
    type_of_class: form1Value?.type_of_class?.value,
    airport_type: form1Value?.service_type === "Domestic" ? "1" : "2",
    first_name: form2Value?.first_name,
    last_name: form2Value?.last_name,
    address1: form2Value?.address1,
    address2: form2Value?.address2,
    city: form2Value?.city?.value,
    state: form2Value?.state?.value,
    display_name: `${form2Value?.first_name} ${form2Value?.last_name} `,
    email: form2Value?.email,
    country: form2Value?.country?.value,
    pincode: form2Value?.pincode,
    phone_number: form2Value?.phone,
    dob: convertDateFormat(form2Value?.dob) || "2025-04-02",
    nationality: form2Value?.country?.label,
    phone: form2Value?.phone,
    country_code: form2Value?.country_code?.value || "-",
    emergency_contact: form2Value?.emergency_contact,
    company_name: form2Value?.company_name,
    emergency_country_code: form2Value?.emergency_country_code?.value || "-",
    service_type:
      form1Value?.arrival_departure_type?.value === "Arrival"
        ? "1"
        : form1Value?.arrival_departure_type?.value === "Departure"
        ? "2"
        : "3" || "-",
    service_id:
      form1Value?.arrival_plan?.value ||
      form1Value?.departure_plan?.value ||
      form1Value?.transit_plan?.value ||
      "-",
    number_of_adults: form2Value?.no_of_adult || "0",
    number_of_child: form2Value?.no_of_child || "0",
    number_of_infant: form2Value?.no_of_infant || "0",
    pan_number:form2Value.pan_number|| '',
      customer_gst_no: form2Value.customer_gst_no||'',
    date_of_departure:
      convertDateFormatBooking(form1Value?.departure_date) || null,
    time_of_departure: form1Value?.departure_time || null,
    departure_airlines: form1Value?.departure_airline || "-",
    arrival_from_city: form1Value?.arrival_city || "-",
    departure_from_city: form1Value?.departure_city || "-",
    departure_flight_number: form1Value?.departure_flight_number || "-",
    arrival_airlines: form1Value?.arrival_airline || "-",
    time_of_arrival: form1Value?.arrival_time || null,
    date_of_arrival: convertDateFormatBooking(form1Value?.arrival_date) || null,
    total_passengers: form2Value?.total_passengers || "0",
    notes: form2Value?.notes || "-",
    gst_number: form2Value?.gst_number || "-",
    arrival_flight_number: form1Value?.arrival_flight_number || "-",
    arival_pnr_by_customer: form1Value?.arival_pnr_by_customer || "-",
    departure_pnr_by_customer: form1Value?.departure_pnr_by_customer || "-",
    number_of_service: form2Value?.no_of_service || "-",
    family_members: familyMember || "-",
    proof_url: "",
    gender_type: "M",
    success_url: DEV_PAYMENT_PROCESSING,
    failure_url: DEV_PAYMENT_PROCESSING,
    booked_type: 1,
     booked_service:isPorterService?"2":"1",
         is_mobile:1,
    // Add promo code to booking data (copied from normal booking)
    promocode_id:  validPromoSuccess?.data?.id  || "",
  };

  const submitBookingData = () => {
    dispatch(insertInstantBookingRequest(bookingValue));
  };

  const handleCloseLoginPopup = () => {
    setShowLoginPopup(false);
    dispatch(resetBookingDetails());
  };

  const handleLoginRedirect = () => {
    // Replace with your actual login route
    const loginUrl = {LOGIN};
    handleRemovePromoCode();
    window.location.href = loginUrl;
  };

  const bookingData = [
    {
      icon: <GroupIcon className="passenger-icon" />,
      title: "Passenger Details",
      fields: [
        { label: "No. of Adults", value: form2Value.no_of_adult || 0 },
        { label: "No. of Children", value: form2Value.no_of_child || 0 },
        { label: "No. of Infants", value: form2Value.no_of_infant || 0 },
        { label: "Total Passengers", value: form2Value.total_passengers || 0 },
      ],
    },
    {
      icon: <FlightTakeoffIcon className="service-icon" />,
      title: "Service Details",
      fields: [
        { label: "Service", value: service || "-" },
        { label: "Service Type", value: form1Value.service_type.value || "-" },
        { label: "Service Plan", value: form1Value.service_type.value || "-" },
        {
          label: "Number of Services",
          value: form2Value.no_of_service || "0",
        },
      ],
    },
    {
      icon: <LocationOnIcon className="location-icon" />,
      title: "Airport Details",
      fields:
        service === "Arrival"
          ? [
              {
                label: "Travel class",
                value: form1Value.type_of_class.label || "-",
              },
              { label: "Airport", value: form1Value.airport.label || "" },
              {
                label: "Arrival Date & Time",
                value:
                  `${form1Value.arrival_date} - ${form1Value.arrival_time} ` ||
                  "",
              },
              {
                label: "Arrival Flight Number",
                value: form1Value.arrival_flight_number || "",
              },
              {
                label: "Arrival PNR Number",
                value: form1Value.arival_pnr_by_customer || "",
              },
              {
                label: "Arrival Airline",
                value: form1Value.arrival_airline || "",
              },
            ]
          : service === "Departure"
          ? [
              {
                label: "Travel class",
                value: form1Value.type_of_class.label || "-",
              },
              { label: "Airport", value: form1Value.airport.label || "-" },
              {
                label: "Departure Date & Time",
                value:
                  `${form1Value.departure_date} - ${form1Value.departure_time} ` ||
                  "",
              },
              {
                label: "Departure Flight Number",
                value: form1Value.departure_flight_number || "-",
              },
              {
                label: "Departure PNR Number",
                value: form1Value.departure_pnr_by_customer || "-",
              },
              {
                label: "Departure Airline",
                value: form1Value.departure_airline || "-",
              },
            ]
          : [
              {
                label: "Travel class",
                value: form1Value.type_of_class.label || "-",
              },
              { label: "Airport", value: form1Value.airport.label || "-" },
              {
                label: "Arrival Date & Time",
                value:
                  `${form1Value.arrival_date} - ${form1Value.arrival_time} ` ||
                  "",
              },
              {
                label: "Arrival Flight Number",
                value: form1Value.arrival_flight_number || "-",
              },
              {
                label: "Arrival PNR Number",
                value: form1Value.arival_pnr_by_customer || "-",
              },
              {
                label: "Arrival Airline",
                value: form1Value.arrival_airline || "-",
              },
              {
                label: "Departure Date & Time",
                value:
                  `${form1Value.departure_date} - ${form1Value.departure_time} ` ||
                  "",
              },
              {
                label: "Departure Flight Number",
                value: form1Value.departure_flight_number || "-",
              },
              {
                label: "Departure PNR Number",
                value: form1Value.departure_pnr_by_customer || "-",
              },
              {
                label: "Departure Airline",
                value: form1Value.departure_airline || "-",
              },
            ],
    },
  ];

  const currencyFormatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
  });

  const discountValue = formValue?.discount;
  const no_of_child_after_discount =
    childDiscount > 0 
      ?(childFamilyMember.length * childDiscount) / 100
 
      : childFamilyMember.length;



const Gross_Total_Service=form2Value.no_of_service;
const no_of_service =isPorterService?parseInt( form2Value.no_of_service ):parseInt( form2Value.no_of_service )-no_of_child_after_discount;
const servicePrice = form1Value.servicePlanPrice ;


  const [discountPrice, setDiscountPrice] = useState(servicePrice);
  const [discountAmout, setDisountAmount] = useState(0);

  const discountedPrices = (customDiscountValue) => {
    if (discountValue > 100) {
      setError("discount", { message: "Enter Between 0-100 %" });
    } else {
      const newDiscountValue =
        customDiscountValue >= 0 ? customDiscountValue : discountValue;
      clearErrors("discount");
      setDisountAmount(servicePrice * (newDiscountValue / 100));
      setDiscountPrice(servicePrice - servicePrice * (newDiscountValue / 100));
    }
  };

  // Calculate promo discount amount (copied from normal booking)
  useEffect(() => {
    if (promoDiscount > 0) {
      const subTotalForPromo =
        parseFloat(no_of_service * servicePrice) -
        (discountAmout || 0);

      if (validPromoSuccess?.data?.discount_type == 2) {
        // Flat amount discount
        setPromoDiscountAmount(promoDiscount);
      } else {
        // Percentage discount
        setPromoDiscountAmount(subTotalForPromo * (promoDiscount / 100));
      }
    } else {
      setPromoDiscountAmount(0);
    }
  }, [
    promoDiscount,
    no_of_service,
    servicePrice,
    discountAmout,
  ]);

  const subTotal =
    parseFloat(no_of_service * servicePrice) - 
    (parseFloat(discountAmout) || 0) -
    (parseFloat(promoDiscountAmount) || 0);

  const orderSummary = {
    totals: [
      form1Value?.servicePlanPrice && {
        label: "Gross Amount",
        value: 0,
        formattedValue: currencyFormatter.format(
          parseFloat(Gross_Total_Service * servicePrice) || 0
        ),
      },
      (adultFamilyMember?.length > 0&& !isPorterService) && {
        label: `Adult Discount(${adultDiscount}%)`,
        value: 0,
        formattedValue: currencyFormatter.format(
          -parseFloat(
            adultFamilyMember?.length * (adultDiscount / 100) * servicePrice
          ) || 0
        ),
      },
      (childFamilyMember?.length > 0&& !isPorterService) && {
        label: `Child Discount(${childDiscount}%)`,
        value: 0,
        formattedValue: currencyFormatter?.format(
          -parseFloat(
            childFamilyMember?.length * (childDiscount / 100) * servicePrice
          ) || 0
        ),
      },
      // Add promo code discount to order summary (copied from normal booking)
      promoDiscount > 0 && {
        label: `Promo Code Discount (${appliedPromoCode} - ${
          validPromoSuccess?.data?.discount_type == 2
            ? `₹${promoDiscount}`
            : `${promoDiscount}%`
        })`,
        value: 0,
        formattedValue: currencyFormatter.format(
          -parseFloat(promoDiscountAmount) || 0
        ),
      },
      form1Value?.servicePlanPrice && {
        label: "SubTotal",
        value: parseFloat(subTotal?.toFixed(2)),
        formattedValue: currencyFormatter.format(
          parseFloat(subTotal?.toFixed(2)) || 0
        ),
      },
      form1Value?.tax > 0 && {
        label: `IGST (${form1Value?.tax_percentage}%)`,
        value:
          parseFloat(subTotal?.toFixed(2)) *
            (parseFloat(form1Value.tax_percentage) / 100) || 0,
        formattedValue: currencyFormatter.format(
          parseFloat(subTotal?.toFixed(2)) *
            (parseFloat(form1Value.tax_percentage) / 100) || 0
        ),
      },
      form1Value?.sgst > 0 && {
        label: `SGST (${form1Value?.sgst_percentage}%)`,
        value:
          parseFloat(subTotal?.toFixed(2)) *
            (parseFloat(form1Value.sgst_percentage) / 100) || 0,
        formattedValue: currencyFormatter.format(
          parseFloat(subTotal?.toFixed(2)) *
            (parseFloat(form1Value.sgst_percentage) / 100) || 0
        ),
      },
      form1Value?.cgst > 0 && {
        label: `CGST (${form1Value?.cgst_percentage}%)`,
        value:
          parseFloat(subTotal?.toFixed(2)) *
            (parseFloat(form1Value.cgst_percentage) / 100) || 0,
        formattedValue: currencyFormatter.format(
          parseFloat(subTotal?.toFixed(2)) *
            (parseFloat(form1Value.cgst_percentage) / 100) || 0
        ),
      },
    ].filter(Boolean),
  };

  const totalAmount = orderSummary.totals.reduce(
    (sum, item) => sum + item.value,
    0
  );
  const formattedTotalAmount = currencyFormatter.format(totalAmount);

  useEffect(() => {
    discountedPrices();
  }, []);

  const updateDiscountValues = async (isChecked) => {
    if (isChecked) {
      setValue("applyComplementary", false);
    } else {
      setValue("applyDiscount", false);
      setValue("discount", 0);
      discountedPrices(0);
    }
  };

  const updateComplementaryValue = async (isChecked) => {
    if (isChecked) {
      setValue("applyDiscount", false);
      setValue("discount", 0);
      discountedPrices(0);
      // Remove promo code when complementary is applied (copied from normal booking)
      if (appliedPromoCode) {
        handleRemovePromoCode();
      }
    } else {
      setValue("applyComplementary", false);
    }
  };

  const renderFields = (fields) =>
    fields.map((item, index) => (
      <Box key={index} className="label-value-container">
        <Typography variant="body1" className="label-style">
          {item.label}
        </Typography>
        <Typography variant="body1" className="value-style">
          {item.value}
        </Typography>
      </Box>
    ));

  return (
    <>
      <TopBar unAuth={true} />
      <ToastContainer />
      
      {/* Custom Login Popup */}
      <Dialog
        open={showLoginPopup}
        onClose={handleCloseLoginPopup}
        maxWidth="sm"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '12px',
            padding: '20px',
          }
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingBottom: '10px',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Avatar sx={{ bgcolor: '#ff6b35' }}>
              <PersonIcon />
            </Avatar>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              Account Already Exists
            </Typography>
          </Box>
          <IconButton onClick={handleCloseLoginPopup}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        
        <DialogContent>
          <Typography variant="body1" sx={{ marginBottom: 2, color: '#666' }}>
            You have already registered with this email or contact number. 
            Please login to your account to continue with the booking.
          </Typography>
          <Typography variant="body2" sx={{ color: '#888' }}>
            If you've forgotten your password, you can reset it on the login page.
          </Typography>
        </DialogContent>
        
        <DialogActions sx={{ paddingTop: '20px', gap: 1 }}>
          <Button
            onClick={handleCloseLoginPopup}
            variant="outlined"
            sx={{
              color: '#666',
              borderColor: '#ddd',
              '&:hover': {
                borderColor: '#bbb',
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleLoginRedirect}
            variant="contained"
            sx={{
              backgroundColor: '#ff6b35',
              '&:hover': {
                backgroundColor: '#e55a2b',
              },
            }}
          >
            Login & Continue
          </Button>
        </DialogActions>
      </Dialog>

      <Box className="container">
        <Box sx={{ marginTop: "100px" }}>
          <Grid container spacing={4}>
            {/* Passenger Details (First Box) */}
            {bookingData[0] && (
              <Grid
                item
                xs={12}
                md={6}
                xl={6}
                key="row1-box1"
              >
                <Paper elevation={4} className="booking-summary-paper">
                  <Box className="booking-summary-content-box">
                    <Box className="booking-heading-alignment">
                      <Avatar className="booking-summary-avatar-style">
                        {bookingData[0].icon}
                      </Avatar>
                      <Typography
                        variant="h6"
                        className="booking-summary-title-style"
                      >
                        {bookingData[0].title}
                      </Typography>
                    </Box>
                    <Divider
                      sx={{
                        margin: "10px 0",
                        borderColor: "#ddd",
                        width: "100%",
                      }}
                    />
                  </Box>
                  {renderFields(bookingData[0].fields)}
                </Paper>
              </Grid>
            )}

            {/* Booking Details (Second Box) */}
            {bookingData[1] && (
              <Grid
                item
                xs={12}
                md={6}
                xl={6}
                key="row1-box2"
              >
                <Paper elevation={4} className="booking-summary-paper">
                  <Box className="booking-summary-content-box">
                    <Box className="booking-heading-alignment">
                      <Avatar className="booking-summary-avatar-style">
                        {bookingData[1].icon}
                      </Avatar>
                      <Typography
                        variant="h6"
                        className="booking-summary-title-style"
                      >
                        {bookingData[1].title}
                      </Typography>
                    </Box>
                    <Divider
                      sx={{
                        margin: "10px 0",
                        borderColor: "#ddd",
                        width: "100%",
                      }}
                    />
                  </Box>
                  {renderFields(bookingData[1].fields)}
                </Paper>
              </Grid>
            )}

            {/* Passenger Information */}
            <Grid item xs={12}>
              <PassengerInfoTable form2Value={form2Value} />
            </Grid>

            {/* Airport Details (Third Box) */}
            {bookingData[2] && (
              <Grid item xs={12} md={6} xl={6} key="row1-box3">
                <AirportDetailsTable form1Value={form1Value} />
              </Grid>
            )}

            {/* Order Summary - Now placed before Promo Code */}
            <Grid item xs={12} md={6}>
              <Paper
                elevation={4}
                className="unauth-booking-summary-order-paper"
              >
                <Box className="booking-summary-order-box">
                  <Avatar className="booking-summary-order-avatar">
                    <ReceiptIcon className="booking-summary-receipticon" />
                  </Avatar>
                  <Typography
                    variant="h6"
                    className="booking-summary-title-style"
                  >
                    Order Summary
                  </Typography>
                </Box>
                <Divider className="booking-summary-divider" />

                {orderSummary.totals.map((item, index) => (
                  <Box key={index} className="booking-summary-order-content">
                    <Typography
                      variant="body1"
                      className="booking-summary-total-label"
                    >
                      {item.label}
                    </Typography>
                    <Typography
                      variant="body1"
                      className="booking-summary-total-value"
                    >
                      {item.formattedValue}
                    </Typography>
                  </Box>
                ))}
                <Divider className="booking-summary-divider" />
                <Box
                  className="booking-summary-order-content"
                  sx={{ paddingBottom: "20px" }}
                >
                  <Typography
                    variant="h6"
                    className="booking-summary-total-label"
                  >
                    Total
                  </Typography>
                  <Typography
                    variant="h6"
                    className="booking-summary-total-value"
                  >
                    {formattedTotalAmount}
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            {/* Promo Code Section - Moved to the bottom, right before buttons */}
            <Grid item xs={12} md={12}>
              <Paper
                elevation={4}
                sx={{ borderRadius: "12px", padding: "20px" }}
              >
                <Box className="booking-summary-order-box">
                  <Avatar className="booking-summary-order-avatar">
                    <LocalOfferIcon className="booking-summary-offer" />
                  </Avatar>
                  <Typography
                    variant="h6"
                    className="booking-summary-title-style"
                  >
                    Apply Promo Code
                  </Typography>
                </Box>
                <Divider className="booking-summary-divider" />

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mt: 2,
                    flexWrap: { xs: "wrap", md: "nowrap" },
                  }}
                >
                  <Typography variant="body1" sx={{ minWidth: "100px" }}>
                    Promo Code:
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      flex: 1,
                      maxWidth: "400px",
                    }}
                  >
                    <TextField
                      size="small"
                      value={promoCode}
                      onChange={(e) => setPromoCode(e.target.value)}
                      placeholder="Enter promo code"
                      disabled={!!appliedPromoCode}
                    />

                    {/* Error message below input */}
                    {validPromoError && (
                      <Typography
                        variant="body2"
                        color="error"
                        sx={{ mt: "4px", fontSize: "0.8rem" }}
                      >
                        {validPromoError}
                      </Typography>
                    )}
                    {appliedPromoCode && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "10px",
                          gap: 1,
                        }}
                      >
                        <Typography variant="body2" color="success.main">
                          Applied: {appliedPromoCode} (
                          {validPromoSuccess?.data?.discount_type == 2
                            ? `${promoDiscount} Rupee`
                            : `${promoDiscount} Percent`}
                          )
                        </Typography>
                        <Button
                          size="small"
                          variant="outlined"
                          color="error"
                          onClick={handleRemovePromoCode}
                        >
                          Remove
                        </Button>
                      </Box>
                    )}
                  </Box>
                  {!appliedPromoCode && (
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleApplyPromoCode}
                      disabled={!promoCode.trim()}
                      sx={{
                        minWidth: "80px",
                        color: "white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "8px",
                        backgroundColor: "#ed6c02",
                      }}
                    >
                      {validPromoLoading ? (
                        <PulseLoader color={"#fff"} size={8} />
                      ) : (
                        "Apply"
                      )}
                    </Button>
                  )}
                </Box>
              </Paper>
            </Grid>

            {/* Next Button */}
            <Grid item xs={12} className="unauth-button-container">
              <Box display="flex" gap={2}>
                <Button
                  variant="contained"
                  className="grey-button"
                  onClick={() => {
                    let passengerDetailsRoute;

                    passengerDetailsRoute =
                      UNAUTHORIZE_BOOKING_PASSENGER_DETAILS;

                    navigate(passengerDetailsRoute, {
                      state: {
                        form1Value: form1Value,
                        form2Value: form2Value,
                        form3Value: formValue,
                      },
                    });
                  }}
                >
                  Back
                </Button>

                <CustomButton
                  variant="contained"
                  className="orange-button"
                  onClick={submitBookingData}
                  loading={loading}
                  text={formValue?.applyComplementary ? "Complmentary" : "Pay"}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};
export default BookingInvoice;